(function($, win) {

  $.fn.inViewport = function(cb) {
     return this.each(function(i,el) {
       function visPx(){
         var elH = $(el).outerHeight(),
             H = $(win).height(),
             r = el.getBoundingClientRect(), t=r.top, b=r.bottom;
         return cb.call(el, Math.max(0, t>0? Math.min(elH, H-t) : (b<H?b:H)));
       }
       visPx();
       $(win).on("resize scroll", visPx);
     });
  };

  function setPaddings() {
    container_size = $('.container').width();
    screen_size = $(window).width();
  }

  //-------------------------------------------
  //Add some helper classes to paginations
  //-------------------------------------------
  function setPagination(){
    $('.post-navigation ul.page-numbers li a.prev').parent('li').addClass('prev-page');
    $('.post-navigation ul.page-numbers li a.next').parent('li').addClass('next-page');
    $('.post-navigation ul.page-numbers li a.prev').addClass('nav-button');
    $('.post-navigation ul.page-numbers li a.next').addClass('nav-button');
    if ($('.post-navigation ul.page-numbers li.prev-page').length === 0) {
      $('.post-navigation ul.page-numbers').prepend('<li class="prev-page off"><span class="icon-arrow rotated"></span></li>');
    }
    if ($('.post-navigation ul.page-numbers li.next-page').length === 0) {
      $('.post-navigation ul.page-numbers').append('<li class="next-page off"><span class="icon-arrow"></span></li>');
    }
  }


  function setAnimations(){

    var elements = [
      '#homeIntro .wrapper h1 .animatedLine',
      '#animatedIcons .tbl .text-wrapper .animatedLine',
      '#planJourney .inner .plan-title .animatedLine',
      '#latestProjects .contentWrapper .inner .projects-title .animatedLine',
      '#defaultWrapper .main-container h1.title .animatedLine',
      '#projectsWrapper .main-content .titleWrapper h1.title .animatedLine',
      '#newsWrapper .main-content .titleWrapper h1.title .animatedLine',
      '.articleWrapper .main-content .titleWrapper h1.title .animatedLine',
      '#resourcesWrapper .main-content .titleWrapper h1.title .animatedLine',
      '#contactWrapper .main-content .titleWrapper h1.title .animatedLine',
      '.initial-hidden'
    ];
    var el_count = elements.length;

    if (!(document.documentMode || /Edge/.test(navigator.userAgent))) {
      console.log('not-edge');
      for (i=0; i < el_count; i++) {
        $(elements[i]).inViewport(function(px){
          if(px > 0) {
            $(this).addClass('moved');
          }
        });
      }

    } else {
      console.log('edge');
      for (i=0; i < el_count; i++) {

        $(elements[i]).addClass('moved');

      }
    }
  }



  $(document).ready(function(){



    //-------------------------------------------
    //Initialize Hero Carousel
    //-------------------------------------------
    if (!$('#homeBanner').hasClass('video-wrapper')) {
      //txt = $('#hero-banner .slider-item:eq(0) .container .row .content>.row>div:last-of-type').html();
      //$('#hero-banner .slider-item:eq(0) .container .row .content').append('<div class="cloned hidden-lg-up">'+txt+'</div>');

      $('#homeBanner.owl-carousel').on('initialized.owl.carousel',function(){
        setPaddings();
      }).owlCarousel({
         loop:true,
         nav:true,
         dots:true,
         autoplay:true,
         autoplaySpeed: 700,
         items:1,
         margin:0,
         navText: ['','']
      });
    }


    $('#latestProjectsSlider').on('initialized.owl.carousel',function(){
      //setPaddings();
    }).owlCarousel({
       loop:true,
       nav:true,
       dots:false,
       autoplay:false,
       autoplaySpeed: 700,
       items:3,
       margin:10,
       slideBy:1,
       navText: ['',''],
       navContainer: '#latestProjects .navWrapper .buttonsWrapper'
    });

    $('#latestNewsSlider').on('initialized.owl.carousel',function(){
      //setPaddings();
    }).owlCarousel({
       loop:true,
       nav:true,
       dots:false,
       autoplay:false,
       items:1,
       margin:0,
       slideBy:1,
       navText: ['',''],
       navContainer: '.newsSliderOuter .controlWrapper>.inner .left',
       animateOut: 'slideOutUp',
       animateIn: 'slideInUp'
    });

    if ($('#inline-gallery .slider-item').length > 1) {
      $('#inline-gallery').on('initialized.owl.carousel',function(){

      }).owlCarousel({
        loop:($('#inline-gallery .slider-item').length > 1) ? true : false,
        nav:($('#inline-gallery .slider-item').length > 1) ? true : false,
        dots:false,
        autoplay:false,
        items:1,
        margin:0,
        slideBy:1,
        navText: ['<span class="icon-chevron"></span>','<span class="icon-chevron"></span>'],
        navContainer: '#defaultWrapper .main-container .gallery-outer',
      });
    }




    if (!(document.documentMode || /Edge/.test(navigator.userAgent))) {

      $('#bannerOuter').inViewport(function(px) {
        tolerance = $('#bannerOuter').outerHeight() + $('#mainHeader').outerHeight();
        if (px > 0 && ($(window).scrollTop() < tolerance)) {
          mid_value = 80 - (($(window).scrollTop() / tolerance)*100);
          side_value = (($(window).scrollTop() / tolerance)*100);
          $('#bannerOuter .bottomClip').css('-webkit-clip-path','polygon(50% '+mid_value+'%, 100% '+side_value+'%, 100% 100%, 50% 100%, 0 100%, 0 '+side_value+'%)');
          $('#bannerOuter .bottomClip').css('clip-path','polygon(50% '+mid_value+'%, 100% '+side_value+'%, 100% 100%, 50% 100%, 0 100%, 0 '+side_value+'%)');
          tri_left = 100 - (( ($(window).scrollTop()) / (tolerance))*100);
          tri_right = (( ($(window).scrollTop()) / (tolerance))*100);
          $('#secMenuWrapper .menuOuter .bottomClip').css('-webkit-clip-path','polygon(0 0, 100% 0, 100% '+tri_right+'%, 0 '+tri_left+'%)');
          $('#secMenuWrapper .menuOuter .bottomClip').css('-clip-path','polygon(0 0, 100% 0, 100% '+tri_right+'%, 0 '+tri_left+'%)');
        }
      });

    }


    if (!(document.documentMode || /Edge/.test(navigator.userAgent))) {

      $('#planJourney .inner').inViewport(function(px) {
        if (px > 0) {
          $(this).addClass('moved');
          setTimeout(function(){
            $('#planJourney .bus').addClass('moved');
          },300);
        }

      });

    } else {
      $('#planJourney .bus').addClass('moved');
    }

    if (!(document.documentMode || /Edge/.test(navigator.userAgent))) {

      $('#planJourney').inViewport(function(px){
        scrollTop = $(document).scrollTop();
        plan_height = $('#planJourney').outerHeight();
        offTop = $('#planJourney').position().top;
        tolerance = offTop + plan_height;

        if (px > 0 && ( (scrollTop + plan_height ) < (tolerance + 300))) {
          bottom_grey_value =  ( (((scrollTop - (offTop - plan_height))/plan_height)*100) /3) ;
          top_grey_value = ((scrollTop - (offTop - plan_height))/plan_height)*100;

          if (top_grey_value < 0) {
            top_grey_value = 0;
          }

          top_green_value = 100 - (((scrollTop - (offTop - plan_height))/plan_height)*100);

          if (top_green_value < 0) {
            top_green_value = 0;
          }

          bottom_green_value =  ((((scrollTop - (offTop - plan_height))/plan_height)*100)/3);

          $('#planJourney .greyBottom').css('-webkit-clip-path','polygon(0 0,0 '+bottom_grey_value+'%,80% 0)');
          $('#planJourney .greyBottom').css('clip-path','polygon(0 0,0 '+bottom_grey_value+'%,80% 0)');
          $('#planJourney .greyTop').css('-webkit-clip-path','polygon(100% '+top_grey_value+'%,0 100%,100% 100%)');
          $('#planJourney .greyTop').css('clip-path','polygon(100% '+top_grey_value+'%,0 100%,100% 100%)');
          $('#planJourney .greenTop').css('-webkit-clip-path','polygon(0 '+top_green_value+'%,0 100%,100% 100%)');
          $('#planJourney .greenTop').css('clip-path','polygon(0 '+top_green_value+'%,0 100%,100% 100%)');
          $('#planJourney .greenBottom').css('-webkit-clip-path','polygon(0 0,0 '+bottom_green_value+'%,100% 0)');
          $('#planJourney .greenBottom').css('clip-path','polygon(0 0,0 '+bottom_green_value+'%,100% 0)');
        }
      });
    }



    $('.actionButton').on('click',function(){
      itemsWrapper = $(this).parent('.buttonHolder').parent('.container').children('.section-items');
      if ($(this).hasClass('opened')) {
        //close
        itemsWrapper.children('li').each(function(index){
          if (index > 2) {
            $(this).slideUp(400,function(){
              $(this).removeClass('shown');
            });
          }
        });
      } else {
        //open
        itemsWrapper.children('li').each(function(index){
          $(this).slideDown(400,function(){
            $(this).addClass('shown');
          });
        });
      }
      $(this).toggleClass('opened');
    });



    $('#defaultWrapper .sidebar .side-menu>ul.projects .type .type-title').on('click',function(){
      $(this).parent('.type').children('.sub-projects').slideToggle();
    });



    $('.burger-btn').on('click',function(){
      $(this).toggleClass('opened');
      $('#responsive-menu').slideToggle();
    });


    $('.respOpen').on('click',function(){
      $(this).parent('.menuOuter').addClass('opened');
      $(this).parent('.menuOuter').children('.secondary-menu').slideDown();
    });

    $('.respClose').on('click',function(){
      $(this).parent('.menuOuter').removeClass('opened');
      $(this).parent('.menuOuter').children('.secondary-menu').slideUp();
    });



    $('.respSideMenuWrapper .title').on('click',function(){
      $(this).parent('.inner').children('.menu').slideToggle();
    });


    setPagination();
    setPaddings();
    setAnimations();
  });


  $('#mainFooter .wrapper .menuWrapper .buttonWrapper').on('click', function(e){
    $('html, body').animate({
      scrollTop: 0
    }, 1000);
  });


  $(window).on('load',function(){
    setPaddings();
    $('body').css('opacity',1);
  });

  $(window).on('resize',function() {
    setPaddings();
  });

  $(window).scroll(function() {
    if (!(document.documentMode || /Edge/.test(navigator.userAgent))) {

      if($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
        $('#mainFooter .wrapper .menuWrapper .buttonWrapper').addClass('animated bounce infinite');
      } else {
        $('#mainFooter .wrapper .menuWrapper .buttonWrapper').removeClass('animated bounce infinite');
      }

    }
  });


})(jQuery, window); // Fully reference jQuery after this point.
